import React, {useState, useRef, useEffect, useMemo} from 'react';
import GuidePopover from '../GuidePopover';
import iconTourBack from '../images/icon_tour_back.png';
import SvgMask from './SvgMask';

const TourStep = ({title, step, currentStepIndex, prevTourTotal, total, stepLength, visible, onPrev, onNext, onClose, mode}) => {
    const overlayRef = useRef(null);
    const [overlayStyle, setOverlayStyle] = useState({});
    let updateKey = 1;

    const rect = useMemo(() => {
        updateKey += 1;
        return step.ref?.current ? step.ref.current.getBoundingClientRect() : {};
    }, [step.ref, window.innerWidth, window.innerHeight]);

    useEffect(() => {
        if (step.ref.current && visible && rect) {
            setOverlayStyle({
                position: 'absolute',
                top: rect.top + window.scrollY - 10,
                left: rect.left + window.scrollX - 10,
                width: rect.width + 20,
                height: rect.height + 20,
                background: 'transparent',
                zIndex: 1001
            });
        }
    }, [step.ref, rect, visible]);

    const cancelText = (<React.Fragment>
        <img src={iconTourBack} width={16} height={16} style={{marginRight: '4px'}} />
        {step.prevText || '上一步'}
    </React.Fragment>);

    return <React.Fragment>
        <GuidePopover
            key={currentStepIndex + `_${updateKey}`}
            description={step.description}
            descImage={step.descImage}
            operateExtraContent={`${prevTourTotal + currentStepIndex + 1} / ${total}`}
            cancelText={(currentStepIndex !== 0) ? cancelText : ''}
            confirmText={(currentStepIndex === stepLength - 1) ? step.confirmText || '完成' : step.nextText || '继续'}
            closable
            title={step.title || title}
            open={visible}
            placement={step.placement}
            beforeCancel={onPrev}
            beforeConfirm={onNext}
            beforeClose={onClose}
            mode={mode}
            destroyTooltipOnHide
            overlayClassName="huibo-tour-step"
        ><div style={overlayStyle} ref={overlayRef} /></GuidePopover>
        {visible && overlayStyle.width && <SvgMask
            targetWidth={overlayStyle.width}
            targetHeight={overlayStyle.height}
            targetTop={overlayStyle.top}
            targetLeft={overlayStyle.left}
            padding={0}
        />}
    </React.Fragment>;
};

export default TourStep;